import { memo } from 'react';
import { MiscScreen } from '@betty/navigation';

function StatusTermsScreen() {
  return <MiscScreen path="/status" />;
}

export default memo(StatusTermsScreen);
